const AboutDescription = ({ description }) => {
    return (
        <div className={`aboutus-section-item  aboutus-section-item--unborded`}>
            <div className="body1"> {description}</div>
        </div>
    );
}

export default AboutDescription;